module.exports = __webpack_public_path__ + "static/media/greyArrow.63a4357d.svg";